export function gridError(reason) {
    return {
        _errorType: "validation",
        reason: reason
    };
}
export function isValid(r) {
    // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !(r._errorType == "validation");
}
